<template>
  <div class="visualizer-elist">
    <div class="visua-right-title">您的事件</div>
    <ul class="visua-namelist">
      <template v-for="event in eventList">
        <c-tooltip
          :key="event.id + '_' + event.event_name"
          :ref="event.id + '_' + event.event_name"
          placement="left-top"
          theme="light"
          :autoHide="false"
        >
          <template slot="tooltip">
            <img :src="event.screenshot" :style="overviewStyle" />
          </template>
          <li
            :class="{'visua-removed': event.status === 'del', 'ename-item': true}"
            @mouseenter="onHover(event.screenshot, event.id + '_' + event.event_name)"
            @mouseleave="onHide(event.id + '_' + event.event_name)"
          >
            <span v-if="event.status === 'add'" class="visua-badge">new</span>
            <div class="ename">{{ event.event_name }}</div>
            <i class="i-del cicon-delete-little1" @click="onDel(event)"></i>
          </li>
        </c-tooltip>
      </template>
      <div v-if="!eventList.length" class="no-data">暂无数据</div>
    </ul>
    <div class="visua-list-foot">
      <c-button size="normal" type="primary" @click="onApply">生效</c-button>
      <c-button size="normal" style="margin-left: 20px" @click="onCancel">取消</c-button>
    </div>
  </div>
</template>
<script>
import { actions } from "../../store/constants";
import { mapState } from "vuex";
import { util } from "../../utils";
export default {
  name: "visuaEventList",
  data() {
    return {
      overviewStyle: {
        width: "auto"
      }
    };
  },
  computed: {
    ...mapState({
      eventList(state) {
        return state.bizVisualizer.eventList;
      }
    })
  },
  mounted() {
    this.getEventList();
  },
  methods: {
    getEventList() {
      this.$store.dispatch(actions.visualizer.queryAndroidEvents, {
        data: JSON.stringify({
          appid: this.appId,
          plat: 1
        })
      });
    },
    onDel(event) {
      this.$store.dispatch(actions.visualizer.delEvent, event);
    },
    onApply() {
      const eventData = {
        events: [],
        dscreen: [],
        devent: [],
        appid: this.appId,
        plat: 1
      };
      const socketData = {
        type: "event_binding_request",
        payload: {
          events: []
        }
      };
      this.eventList.forEach(event => {
        if (event.status === "add") {
          delete event.status;
          delete event.screenshot;
          eventData.events.push(event);
          socketData.payload.events.push(event);
        } else if (event.status === "del") {
          eventData.devent.push(event.id);
          eventData.dscreen.push(event.id);
        } else {
          socketData.payload.events.push(event);
        }
      });
      this.$emit("bindEvents", JSON.stringify(socketData));
      this.$store.dispatch(actions.visualizer.applyAllEvents, eventData)
      .finally(() => {
        this.getEventList()
      })
    },
    onCancel() {
      this.$store.dispatch(actions.visualizer.cancel)
    },
    onHover(src, ref) {
      const img = new Image();
      img.onload = () => {
        this.overviewStyle.width = img.width / 2 + "px";
        const tooltip = this.$refs[ref][0];
        tooltip.show();
      };
      img.src = src;
    },
    onHide(ref) {
      const tooltip = this.$refs[ref][0];
      tooltip.hide();
    }
  }
};
</script>
<style lang="sass">
@import '../iosVisualizer/styles/eventList'
</style>
